import { green, grey, orange } from "@mui/material/colors";

import type { ArasScoreBand } from "./aras-score-types";

/** Low ARAS band: dot + score (design spec). */
export const ARAS_RED = "#B3261E";

/** Chevron column — fixed so expanded panel `marginLeft` matches dot column. */
export const ARAS_CHEVRON_COL_WIDTH = "1.125rem";
/** Space between chevron column and status dot (must match row button `gap`). */
export const ARAS_CHEVRON_DOT_GAP = "0.5rem";
/** Gray expanded panel: left edge lines up with dots (`chevronCol + gap`). */
export const ARAS_EXPANDED_PANEL_MARGIN_LEFT = `calc(${ARAS_CHEVRON_COL_WIDTH} + ${ARAS_CHEVRON_DOT_GAP})`;
export const ARAS_EXPANDED_PANEL_BORDER = "1px solid #0000000d";

/** Popover body horizontal padding — dividers use negative margin to span full paper width. */
export const ARAS_BODY_PADDING_X = "0.75rem";
export const ARAS_DIVIDER_LINE = "1px solid #0000000d";

export const arasFullBleedDividerSx = {
  borderTop: ARAS_DIVIDER_LINE,
  marginLeft: `calc(-1 * ${ARAS_BODY_PADDING_X})`,
  marginRight: `calc(-1 * ${ARAS_BODY_PADDING_X})`,
};

/** Primary copy: labels, scores, header, tooltips. */
export const ARAS_FONT_PRIMARY = "11px";
/** Italic body inside expanded gray panels. */
export const ARAS_FONT_EXPANDED = "10px";

/**
 * Quil renders many text nodes as `MuiTypography-root` (e.g. `data-testid="qtypography"`).
 * Target that class so theme `body1` / 0.875rem does not win over ARAS sizes.
 */
export const arasPopoverMuiTypographyPrimarySx = {
  "& .MuiTypography-root": {
    fontSize: `${ARAS_FONT_PRIMARY} !important`,
  },
};

export const arasExpandedPanelMuiTypographySx = {
  "& .MuiTypography-root": {
    fontSize: `${ARAS_FONT_EXPANDED} !important`,
  },
};

export const arasFooterMuiTypographySx = {
  fontSize: `9px !important`,
};

export const footerSx = {
  fontStyle: "italic",
  color: grey[600],
  lineHeight: "12.6px",
};

/** Row separator — bleeds past horizontal padding so the line spans full card width. */
export const rowDividerSx = arasFullBleedDividerSx;

export const BAND_STYLES: Record<
  ArasScoreBand,
  { dot: string; score: string }
> = {
  red: { dot: ARAS_RED, score: ARAS_RED },
  orange: { dot: orange[700], score: orange[900] },
  green: { dot: green[600], score: green[800] },
};
